import { EmptyStateProps } from './EmptyState.types';

import { EmptyBox } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { ButtonV2 } from '../../atoms/Button/Button.v2';

export const EmptyState = ({
  microcopy,
  onClick,
  className = '',
}: EmptyStateProps) => {
  return (
    <section
      data-test="empty-state"
      aria-label={microcopy.title}
      className={c(
        'flex flex-col items-center justify-center gap-10 p-10',
        className
      )}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="p-5">
          <EmptyBox size={148} className="block md:hidden" aria-hidden="true" />
          <EmptyBox size={176} className="hidden md:block" aria-hidden="true" />
        </div>
        <h2 className="text-black/87 text-center text-md font-semibold leading-6 tracking-[-.252px]">
          {microcopy.title}
        </h2>
        <p className="body-tiny text-center font-normal text-black/85">
          {microcopy.description}
        </p>
      </div>
      {onClick && microcopy.cta && (
        <ButtonV2
          shape="square"
          size="small"
          label={microcopy.cta}
          onClick={onClick}
        />
      )}
    </section>
  );
};
